import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import Homepage from './pages/Homepage';
import AdminDashboard from './pages/admin/AdminDashboard';
import StudentDashboard from './pages/student/StudentDashboard';
import TeacherDashboard from './pages/teacher/TeacherDashboard';
import LoginPage from './pages/LoginPage';
import AdminRegisterPage from './pages/admin/AdminRegisterPage';
import ChooseUser from './pages/ChooseUser';
import './index.css';
import ContactUs from './pages/ContactUs';
import ExamPaperGenerate from './pages/ExamPaper';
import FaqsPage from './pages/FaqsPage';
import NewsPage from './pages/News';
import CoursesPage from './pages/Courses';
import ErrorPage from './pages/ErrorPage';
import Test from './pages/Test';
import Test1 from './pages/Test1';




// Use a known stable version (example: 2.11.338)
const App = () => {
  const { currentRole } = useSelector(state => state.user);

  return (
    <Router>
      {currentRole === null &&
        <Routes>
            
          <Route path="/" element={<Homepage />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/faqs" element={<FaqsPage/>} />
          <Route path="/news" element={<NewsPage/>} />
          <Route path="/courses" element={<CoursesPage/>} />
          
          <Route path="/test" element={<Test/>} />
          <Route path="/test1" element={<Test1/>} />
       
          <Route path="/error" element={<ErrorPage/>} />


          
          <Route path="/exam-paper" element={<ExamPaperGenerate />} />
          <Route path="/choose" element={<ChooseUser visitor="normal" />} />
          <Route path="/chooseasguest" element={<ChooseUser visitor="guest" />} />

          <Route path="/Adminlogin" element={<LoginPage role="Admin" />} />
          <Route path="/Studentlogin" element={<LoginPage role="Student" />} />
          <Route path="/Teacherlogin" element={<LoginPage role="Teacher" />} />

          <Route path="/Adminregister" element={<AdminRegisterPage />} />

          <Route path='*' element={<Navigate to="/" />} />
        </Routes>}

      {currentRole === "Admin" &&
        <>
          <AdminDashboard />
        </>
      }

      {currentRole === "Student" &&
        <>
          <StudentDashboard />
        </>
      }

      {currentRole === "Teacher" &&
        <>
          <TeacherDashboard />
        </>
      }
    </Router>
  )
}

export default App